"use client";
import { Input } from "cy-fe/src/components/Forms/Input";
import { Button, Label } from "cy-fe";
import { useState } from "react";
import { PhoneNumberInput, PhoneNumber } from "cy-ui/components/PhoneNumber";
import { clientFeatureEnabled } from "cy-util/src/utils/featureFlag";
import { Tab, TabButton } from "../components/tabs";

export interface LoginDetails {
  userId: string | null;
  mobile: PhoneNumber | null;
}

export enum TabType {
  UserId = "UserId",
  Phone = "phone",
}
export function ResetRequestForm({
  onContinue,
}: {
  onContinue: (args: LoginDetails) => Promise<void>;
}) {
  const emailLoginDisabled = clientFeatureEnabled("EMAIL_LOGIN_DISABLED");

  const [selectedTab, setSelectedTab] = useState<TabType>(TabType.Phone);
  const [login, setLogin] = useState<LoginDetails>({
    userId: null,
    mobile: { isd: "27", number: "" },
  });

  const submitHandler = async () => {
    await onContinue(login);
  };

  return (
    <>
      <div className="mx-auto mt-5 mb-5 flex w-fit">
        <span className="mr-2 text-sm font-light">
          Enter your login details below and we will send you a code you can use
          to reset it
        </span>
      </div>
      <div className="text-default mx-auto w-[90dvw] max-w-[90dvw] space-y-6 px-2 sm:max-w-lg">
        <Tab className="" selectedTab={selectedTab} onChange={setSelectedTab}>
          <TabButton
            selected={selectedTab === TabType.Phone}
            onchange={setSelectedTab}
            value={TabType.Phone}
          >
            Mobile
          </TabButton>
          <TabButton
            selected={selectedTab === TabType.UserId}
            onchange={setSelectedTab}
            value={TabType.UserId}
          >
            User Id
          </TabButton>
        </Tab>
        <div>
          {selectedTab === TabType.UserId ? (
            <>
              <Label className="text-sm font-light" htmlFor="email">
                Your&nbsp;
                {emailLoginDisabled ? null : "email / "}
                customer id
              </Label>
              <Input
                onChange={(e) =>
                  setLogin({ mobile: null, userId: e.target.value })
                }
                vSize="lg"
                value={login.userId || ""}
                id="email"
                autoComplete={emailLoginDisabled ? "customer_id" : "email"}
                name="email"
                placeholder=""
                type={emailLoginDisabled ? undefined : "email"}
              />
            </>
          ) : (
            <>
              <Label className="text-sm font-light">Your mobile number</Label>
              <PhoneNumberInput
                value={{
                  isd: login.mobile?.isd || "27",
                  number: login.mobile?.number || "",
                }}
                onChange={(value) => setLogin({ mobile: value, userId: null })}
              />
            </>
          )}
        </div>
        <div>
          <Button
            type="button"
            vSize="lg"
            className="w-full"
            onClick={submitHandler}
          >
            Reset Password
          </Button>
        </div>
      </div>
    </>
  );
}
